import React from 'react'

import styled from '@emotion/styled'
import { mq } from '../../../_style'

const Container = styled.p`
  margin-bottom: 20px;
  font-size: 12px;
  color: ${props => props.color};
  line-height: 1;
  ${mq.sp} {
    font-size: 14px;
  }
`
export default class Taste extends React.Component {
  render() {
    return(
      <Container color={this.props.color}>
        {this.props.children}
      </Container>
    )
  }
}
